import { QAlert } from "./QAlert";

export class QRefreshViewerChartAlert extends QAlert {
  constructor() {
    super();
    this.fRequestChartID = null; // use to request when doc didnt load
  }

  ExecuteCustomCommand(aCmd) {
    var panelHandled = true;
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = this.fWSMgr;
    switch (cmdCode) {
      case "doRefresh":
        wsMgr.RefreshBaseFromSource(null, this.fRequestChartID);
        break;
      default:
        panelHandled = false;
        break;
    }
    return panelHandled;
  }
}
